import React, { useEffect } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { RedirectAs404, generateToken } from "./utils/Utils";
import PrivateRoute from "./route/PrivateRoute";

import Layout from "./layout/Index";

import Faq from "./pages/others/Faq";
import Terms from "./pages/others/Terms";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Success from "./pages/auth/Success";
import InvoicePrint from "./pages/pre-built/invoice/InvoicePrint";
import { useLocation } from "react-router";
import Swal from "sweetalert2";
import OnBoarding from "./pages/pre-built/onBoarding/OnBoarding";

const App = (props) => {

  const location = useLocation();

  let countdownDuration = 120; // 2 minutes in seconds
let timerInterval;

const updateDialogWithCountdown = () => {
  const minutes = Math.floor(countdownDuration / 60);
  const seconds = countdownDuration % 60;
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');
  if(Swal?.getContainer()?.querySelector(".swal2-html-container h4")){
    Swal.getContainer().querySelector(".swal2-html-container h4").innerHTML = `${formattedMinutes}:${formattedSeconds}`;
  }
};

// Start the countdown timer
const startCountdownTimer = () => {
  timerInterval = setInterval(() => {
    countdownDuration--;
    updateDialogWithCountdown();
    if (countdownDuration <= 0) {
      clearInterval(timerInterval);
      Swal.close(); // Close the dialog after countdown finishes
    }
  }, 1000); // Update every second
};

  const tokenRequest = () => {
    let formData = localStorage?.getItem("formCd") ? JSON?.parse(localStorage?.getItem("formCd")) : {};
    let generateTokens = generateToken(formData);
  }
  
useEffect(() => {
  if (location.pathname?.trim() !== "/" && location.pathname?.trim() !== "/login/onBoarding" && !(location.pathname)?.toLowerCase()?.includes("login/onboarding")) {
    setTimeout(() => {
      let counts = localStorage?.getItem("countsAdmin") ? JSON?.parse(localStorage?.getItem("countsAdmin")) : Date.now();
      let difference = Math.floor((Date.now() - counts) / 1000);
      if (difference < 1080) {
        const InterValTime = setInterval(() => {
          if (difference <= 1080) {
            difference++;
          } else {
            clearInterval(InterValTime)
            tokenRequest()
          }
        }, 1000);
      } else {
        tokenRequest()
      }
    }, 5000);
  }
}, []);

  
  return (
    <Switch>
      {/* Auth Pages */}
      <Route exact path={`${process.env.PUBLIC_URL}/auth-success`} component={Success}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/auth-reset`} component={ForgotPassword}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/auth-register`} component={Register}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/`} component={Login}></Route>

      {/* Print Pages */}
      <Route exact path={`${process.env.PUBLIC_URL}/invoice-print/:id`} component={InvoicePrint}></Route>

      {/* Helper pages */}
      <Route exact path={`${process.env.PUBLIC_URL}/auths/terms`} component={Terms}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/auths/faq`} component={Faq}></Route>

      <Route exact path={`${process.env.PUBLIC_URL}/invoice-print`} component={InvoicePrint}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/login/onBoarding`} component={OnBoarding}></Route>


      {/*Main Routes*/}
      <PrivateRoute exact path="" component={Layout}></PrivateRoute>
      <Route component={RedirectAs404}></Route>
    </Switch>
  );
};
export default withRouter(App);
